import { CircularProgress, useTheme } from "@mui/material";
import Error from "~components/Templates/Error";

const ContentLoading = () => {
  const theme: any = useTheme();

  return (
    <Error isSigned={true}>
      <CircularProgress sx={{ color: theme.palette.common.white }} />
    </Error>
  );
};

export default ContentLoading;
